import { addSpaceForCardNumber } from './addSpaceForCardNumber';
import { CardResponse } from '@/api/general';

export const returnCardNumber = (
    cardData: CardResponse | undefined,
    isShowSecureCardInfo: boolean,
) => {
    if (!cardData) return '';
    const first = cardData?.panFirst6 || '      ';
    const last = cardData?.panLast4 || '    ';
    let number = addSpaceForCardNumber(first + '******' + last);
    if (isShowSecureCardInfo && cardData?.pan) {
        number = addSpaceForCardNumber(cardData?.pan || '');
    }
    return number;
};
